
export const solutions = {
  '1gb.solutions': '1Gbソリューション',
  '10gb.solutions': '10Gbソリューション',
  '1gb.vpx.accessories': '1Gb VPXアクセサリ',
  'software': 'ソフトウェア',
  '1gb.description': '高性能1Gb AV over IPソリューション',
  '10gb.description': '超高性能10Gb AV over IPソリューション',
  'vpx.accessories.description': '1Gb VPXソリューションに不可欠なアクセサリ',
  'software.description': 'AuroraのIPBaseT Managerソフトウェアは、Aurora IPBaseT AV over IP製品のIPX、VPX、およびVLXシリーズ向けのオールインワン制御アプリケーションです',
  'avoip.solutions': 'AVOIPソリューション',
  'choose.network.speed': '優先ネットワーク速度を選択してください',
  'touch.controllers': 'タッチコントローラー',
  'touch.controllers.description': 'シームレスな制御を実現するプロフェッショナルタッチパネルインターフェイス',
  'control.processors': 'コントロールプロセッサー',
  'control.processors.description': 'システム管理用の高度なコントロールプロセッサー',
  'reax.software': 'ソフトウェア',
  'reax.software.description': 'プロフェッショナル制御システム開発ソフトウェア',
  'reax.accessories': 'アクセサリー',
  'reax.accessories.description': 'ReAXシステムに不可欠なアクセサリ',
  'reax.control.solutions': 'ReAXコントロールソリューション',
  'choose.control.solution': '優先コントロールソリューションを選択してください',
  'digital.signal.processors': 'デジタルシグナルプロセッサー',
  'dsps.description': 'プロフェッショナルオーディオ処理ソリューション',
  'amplifiers': 'アンプ',
  'amplifiers.description': '高性能オーディオ増幅',
  'speakers': 'スピーカー',
  'speakers.description': 'プレミアムオーディオ再生ソリューション',
  'audio.solutions': 'オーディオソリューション',
  'choose.audio.solution': '優先オーディオソリューションを選択してください',
};
